module.exports = __webpack_public_path__ + "img/xycx_p.a222351e.png";